import React from 'react'
import {AirportList} from '../../components'

const Airport = () => {
  return (
    <div>
      <AirportList/>
    </div>
  )
}

export default Airport